import { render, staticRenderFns } from "./Cor.vue?vue&type=template&id=ec8d1ece&"
import script from "./Cor.vue?vue&type=script&lang=js&"
export * from "./Cor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports